import React from 'react';
import { capacityTone, euros, previewCycleLabel, remainingPercent, renewalLabel, scheduledPlanName, type PreviewState } from './model';

export function UsagePreviewMeter({ state, onManage }: { state: PreviewState; onManage: () => void }) {
  const percent = remainingPercent(state);
  const tone = capacityTone(percent), target = scheduledPlanName(state);
  return <div className="space-y-1.5 text-xs">
    <div className="flex items-center gap-3">
      <div role="progressbar" aria-label="Capacidad mensual restante" aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent} className="h-1 flex-1 overflow-hidden rounded-full bg-raised">
        <div className={`h-full rounded-full transition-[width,background-color] duration-300 motion-reduce:transition-none ${tone.bar}`} style={{ width: `${percent}%` }} />
      </div>
      <span className={`font-semibold tabular-nums transition-colors duration-300 motion-reduce:transition-none ${tone.text}`}>{percent} %</span>
    </div>
    <div className="flex flex-wrap justify-between gap-x-2 gap-y-1 text-[11px] text-muted">
      <span>{previewCycleLabel(state)}: {renewalLabel(state.renewAt)}{target ? ` → ${target}` : ''}</span><span>Créditos: <span className="text-ink tabular-nums">{euros(state.creditCents)}</span></span>
    </div>
    <button type="button" onClick={onManage} className="min-h-9 text-left text-xs font-semibold text-juris hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-juris rounded">Gestionar plan y créditos</button>
  </div>;
}
